import React from "react";
import { useEffect, useState, useRef } from "react";

import { connect } from "react-redux";

import Loader from "../Loader";

import {
  setPromotionsPageDefault,
  setPromotionsPageDefaultFalse,
} from "../../redux/actions/promotions";
import { setAlert } from "../../redux/actions/alerts";

import FeaturedTable from "../Shared/FeaturedTable";
import DeleteForm from "./Forms/DeleteForm";
import Modal from "../Shared/Modal";
import DefaultPromotionFormRow from "./Forms/DefaultPromotionFormRow";

const DefaultPromotionForm = ({
  setPromotionsPageDefault,
  setPromotionsPageDefaultFalse,
  promotion: {
    isLoading,
    promotionPageDefault,
  },
}) => {
  
  const [isDisabled, setIsDisabled] = useState(false);
  const [missingIndex, setMissingIndex] = useState([])
  const [clear, setClear] = useState(0);
  const [selectedContent, setSelectedContent] = useState(null);

  const defaultFeatured = {
    id: null
  }

  const [formValues, setFormValues] = useState([
    defaultFeatured
  ]);
  
  useEffect(() => {
    let currentForm = []

    if (promotionPageDefault?.length > 0) {
      for (let featured of promotionPageDefault) {
        currentForm = [
          ...currentForm,
          {
            id: featured.promotion_id,
            name: featured.title,
            featuredId: featured.promotion_id
          }
        ]
      }
    } else {
      currentForm = [defaultFeatured]
    }
    
    setFormValues([
      ...currentForm
    ])

  }, [promotionPageDefault]);

  const processChange = (changingData, i) => {

    let dataToChange = formValues
    dataToChange[i] = {
        ...dataToChange[i],
        ...changingData
    }

    setFormValues([...dataToChange])
  }

  const handleClear = (i) => {
    let dataToChange = formValues

    if (dataToChange[i]?.featuredId) {
        return setSelectedContent(dataToChange[i])
    }

    dataToChange.splice(i, 1)
    
    setFormValues([...dataToChange])
    setMissingIndex([])
  }

  const handleSubmit = async () => {

      setIsDisabled(true);

      setTimeout(() => {
        setIsDisabled(false);
      }, 3000);
      await setPromotionsPageDefaultFalse();
      let promotionId;
      // Loops through the formValue state and fires off requests for each promotion
      // formValues[promotion][`${promotion}-select`]  will dynamically grab the specific properties on the formValue obj
      for (const promotion of formValues) {
        if (promotion.id) {
          promotionId = promotion.id;
          
          setPromotionsPageDefault(promotionId);
        }
      }

      setClear(prevClear => prevClear + 1)
  };

  return isLoading ? (
    <Loader />
  ) : (
      <>
        <FeaturedTable
            tableName={'Default Promotions - Featured Promotion Page'}
            addButtonName={'New Featured'}
            featuredData={formValues}
            FeaturedForm={DefaultPromotionFormRow}
            handleSubmit={handleSubmit}
            handleChangeData={processChange}
            defaultFeatured={defaultFeatured}
            setFeaturedData={setFormValues}
            missingIndex={missingIndex}
            clearFeaturedRow={handleClear}
            clear={clear}
            addedStyles={{maxWidth: '1920px'}}
            disabled={isDisabled}
            setSelectedContent={setSelectedContent}
            maxRows={5}
        />
        <Modal
            open={selectedContent ? true : false}
            setOpen={() => setSelectedContent(null)}
            component={<DeleteForm
                selectedContent={selectedContent}
                updatedData={{
                    promotion_page_default: false,
                }}
                handleClose={() => setSelectedContent(null)}
            />} 

        />
      </>
    
  );
};

const mapStateToProps = (state) => ({
  promotion: state.promotion,
});

export default connect(mapStateToProps, {
  setAlert,
  setPromotionsPageDefault,
  setPromotionsPageDefaultFalse,
})(DefaultPromotionForm);
